<div class='page'>
    <div class=linear>
        <mat-form-field mat-error >
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Search...">
            
          </mat-form-field>

    </div>

      <table mat-table [dataSource]="invitations" class="mat-elevation-z8 stretch" *ngIf="!!superAdmin">
      
        
    
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let invitation"> <a target="_blank" href="https://console.firebase.google.com/u/0/project/studies-151020/database/data/Invitations/{{org}}/{{invitation.id}}">{{invitation?.email}} </a></td>
        </ng-container>
        <ng-container matColumnDef="entityId">
          <th mat-header-cell *matHeaderCellDef> EntityId/Shortname </th>
          <td mat-cell *matCellDef="let invitation"> <span [ngClass]="{'error': invitation.entityId !== entityId }">{{invitation.entityId}}</span> </td>
        </ng-container>
     
        <ng-container matColumnDef="response">
          <th mat-header-cell *matHeaderCellDef> Responded At </th>
          <td mat-cell *matCellDef="let invitation"> 
              <a 
                target="_blank" 
                href="https://console.firebase.google.com/u/0/project/studies-151020/database/data/InvitationResponses/{{org}}/{{invitation.id}}"><span [ngClass]="{'error': !responses || responses[invitation?.id] !== invitation?.email}"> {{!!responses ? responses[invitation?.id] : ""}}</span></a> 
              <span *ngIf="!responses || !responses[invitation?.id]" class="error">No Response</span>
            </td>

        </ng-container>

        <ng-container matColumnDef="errors">
            <th mat-header-cell *matHeaderCellDef>Errors </th>
            <td mat-cell *matCellDef="let invitation"> <span [ngClass]="{'error': !responses || responses[invitation?.id] !== invitation?.email}">{{ !!responses && responses[invitation?.id] !== invitation?.email ? "Emails don't match" : "No Errors"}}</span> </td>
          </ng-container>

  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
</div>


